import type { ReactNode } from "react";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

/**
 * A short page that says one thing — not found, payment cancelled, something
 * broke — and offers the next step. Left-aligned like every other page, with a
 * small ridge drawing instead of an icon tile.
 */
export function MessagePage({
	title,
	children,
	actions,
	aside,
}: {
	title: string;
	children?: ReactNode;
	actions?: ReactNode;
	/** Secondary content under the actions, e.g. help or technical details. */
	aside?: ReactNode;
}) {
	return (
		<div className="flex min-h-dvh flex-col bg-canvas">
			<SiteHeader width="max-w-2xl" />
			<main className="mx-auto w-full max-w-2xl flex-1 px-4 pt-10 pb-16 sm:px-6 sm:pt-16">
				<svg viewBox="0 0 96 32" className="h-8 w-24 text-ink" aria-hidden="true">
					<circle cx="62" cy="22" r="8" fill="var(--c-sun)" />
					<path d="M0 30 L18 12 L30 22 L44 6 L60 24 L72 16 L96 30 Z" fill="currentColor" />
				</svg>
				<h1 className="mt-5 text-[26px] font-bold leading-tight tracking-[-0.025em] text-ink sm:text-4xl">{title}</h1>
				{children && (
					<div className="mt-2 max-w-[52ch] space-y-2 text-[15px] leading-relaxed text-muted sm:text-base">
						{children}
					</div>
				)}
				{actions && <div className="mt-6 flex flex-wrap gap-2">{actions}</div>}
				{aside && <div className="mt-10 border-t border-line pt-5">{aside}</div>}
			</main>
			<SiteFooter width="max-w-2xl" />
		</div>
	);
}
